import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import constantURL from '../../../shared/constantURL';
import { BasePostService } from '../../../shared/services/basePostService.service';
import { AuthService } from '../../../shared/services/auth.service';
import { GlobalLoaderService } from '../../../shared/services/global-loader.service';

@Injectable({
  providedIn: 'root'
})
export class SignupService extends BasePostService {

  constructor(http: HttpClient, gls: GlobalLoaderService, private auth: AuthService, r: Router) {
    super(http, gls, r, auth);
  }
  _path = constantURL.auth.signup.signup;

  async signUp() {
    return this.make();
  }
}
